import { joinWithCommas } from './utils';

export default function studentStory(hit, overline) {
  const { title, url, program, intro_quote, thumbnail } = hit;

  const renderedThumbnail = thumbnail
    ? `
    <div class="tease__img--container">
      <img class="tease__img" src="${thumbnail}" alt="${title}" />
    </div>
  `
    : '';

  const renderedProgram = program
    ? `
    <div class="tease__desc tease__desc--program">
      ${program}
    </div>
  `
    : '';

  const renderedIntroQuote = intro_quote
    ? `<div class="tease__desc tease__desc--quote">${intro_quote}</div>`
    : '';

  return `
    <a href="${url}" class="tease__story">
      ${
  hit[overline] !== undefined
    ? `<span class="tease__overline tease__overline--wide">${joinWithCommas(
      hit[overline],
    )}</span>`
    : ''
}
      <div class="tease__inner tease__inner--story">
        ${renderedThumbnail}
        <div class="story__quote ${!renderedThumbnail ? 'story__quote--no-img' : ''}">
          ${renderedIntroQuote}
          <h2 class="tease__name">
            <span class="tease__name--inner">${title}</span>
          </h2>
          ${renderedProgram}
        </div>
      </div>
    </a>
    `;
}
